import React, { useState } from 'react';
import { View } from 'react-native';
import Toast from 'react-native-toast-message';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { centralAPI } from '../services/central-api';
import { translate } from '../services/translate';
import { ClientError } from '../services/central-api/base-service';
import Container from '../components/Container';
import Card from '../components/Card';
import MyAppText from '../components/MyAppText';
import Header from '../components/Header';
import CustomButton from '../components/CustomButton';
import { WindowInformation } from '../services/window-information';
import { forceRedirectToLogin } from '../services/navigation-assistant';
import PasswordForm from '../components/PasswordForm';
import { getPasswordRequirements } from '../services/password-requirements';

export default function RotatePassword() {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const isFormValid =
        oldPassword !== '' &&
        password !== '' &&
        confirmPassword === password &&
        getPasswordRequirements(password).isValid;

    async function save() {
        try {
            await centralAPI.updateOwnUser({
                oldPassword,
                password,
                confirmPassword
            });
            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
            forceRedirectToLogin();
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <Container>
            <Header title={translate('updatePassword')} />
            <Card scrollView={true}>
                <View style={styles.pageCenter(windowInfo.isMobile)}>
                    <View style={styles.container(windowInfo.isMobile)}>
                        <View style={{ gap: 16 }}>
                            <MyAppText style={styles.attentionText}>{translate('attention')}!</MyAppText>
                            <MyAppText style={styles.attentionSubText}>{translate('rotatePasswordExplanation')}</MyAppText>
                        </View>
                        <View style={styles.subTitleContainer}>
                            <MyAppText style={styles.detailsFont}>{translate('securityPassword')}</MyAppText>
                        </View>
                        <PasswordForm
                            oldPassword={oldPassword}
                            password={password}
                            confirmPassword={confirmPassword}
                            onChangeOldPassword={setOldPassword}
                            onChangePassword={setPassword}
                            onChangeConfirmPassword={setConfirmPassword}
                        />
                        <View style={{ alignItems: 'flex-end' }}>
                            <CustomButton
                                onPress={() => save()}
                                text={translate('saveChanges')}
                                disabled={!isFormValid}
                            />
                        </View>
                    </View>
                </View>
            </Card>
        </Container>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: (isMobile: boolean) => ({
        gap: 16,
        maxWidth: isMobile ? undefined : 700
    }),
    pageCenter: (isMobile: boolean) => ({
        justifyContent: 'center',
        alignItems: isMobile ? undefined : 'center'
    }),
    attentionText: {
        fontSize: 22,
        color: theme.colors.neutral['500'],
        fontWeight: '700',
    },
    attentionSubText: {
        fontSize: 16,
        fontWeight: '400',
        color: theme.colors.neutral['400'],
    },
    detailsFont: {
        fontSize: 16,
        fontWeight: '600',
        color: theme.colors.primary['500']
    },
    subTitleContainer: {
        borderBottomWidth: 1,
        borderColor: theme.colors.primary['200'],
        paddingBottom: 8
    },
}));
